import React from 'react'
import { useIntl } from 'react-intl'

import { Text } from 'mailup-web-components'

const Description = () => {
  const intl = useIntl()
  return (
    <Text>
      {intl.formatMessage(
        { id: 'Load.EmailCheckUp.PlainTextVersionDesc' },
        { strong: chunks => <strong>{chunks}</strong>, linebreak: () => <br /> }
      )}
    </Text>
  )
}

export default Description
